import { render, staticRenderFns } from "./CardWithTitle.vue?vue&type=template&id=4e3309a7&scoped=true"
import script from "./CardWithTitle.vue?vue&type=script&lang=ts"
export * from "./CardWithTitle.vue?vue&type=script&lang=ts"
import style0 from "./CardWithTitle.vue?vue&type=style&index=0&id=4e3309a7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3309a7",
  null
  
)

export default component.exports